var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderChallengeDisplay'),_c('HeaderChallengeEffects'),_c('HeaderPrestigeGroup'),(_vm.hasReality)?_c('br'):_vm._e(),_c('HeaderBlackHole')],1)}
var staticRenderFns = []

export { render, staticRenderFns }